import config from 'config';
import { forEach, get } from 'lodash';
import apolloClient from 'store/apolloClient';
import { log, errorLog } from 'shared/utils/logger';
import { SubscriptionClient } from 'subscriptions-transport-ws/dist/index';


const INVALID_JWT_ERROR = 'WS: Invalid JWT';

let subscriptions = {};
let wsClient = null;

export const getWSClient = () => {
  if (!wsClient) {
    wsClient = new SubscriptionClient(config.ws_server, {
      lazy: true,
      reconnect: true,
      reconnectionAttempts: 10,
      connectionParams: () => (Object.freeze({ headers: { authentication: `Bearer ${ localStorage.getItem('jwt') }` } })),
    });

    wsClient.connectionCallback = err => {
      if (get(err, 'message') === INVALID_JWT_ERROR) {
        wsClient.close();
      }
    };
  }

  return wsClient;
};

const checkWSConnection = () => {
  if (wsClient.status === 3) wsClient.connect();
};

export const subscribeWS = (query, variables, onMessage, queryName) => {
  if (subscriptions[queryName]) subscriptions[queryName].subscription.unsubscribe();
  checkWSConnection();

  subscriptions[queryName] = { options: { query, variables }, onMessage, queryName };
  subscriptions[queryName].subscription = apolloClient
    .subscribe({ query, variables })
    .subscribe({
      next(data) {
        onMessage(data);
      },
    });
};


export const unsubscribeWS = (actionName) => {
  if (!subscriptions[actionName]) return;

  return Promise.resolve()
    .then(() => subscriptions[actionName].subscription.unsubscribe())
    .then(() => delete subscriptions[actionName])
    .then(() => log(`unsubscribe ${ actionName } success`))
    .catch((err) => errorLog(`unsubscribe ${ actionName } failure`, err));
};


export const disconnectWS = () => {
  return Promise.resolve()
    .then(() => wsClient.unsubscribeAll())
    .then(() => wsClient.close())
    .then(() => subscriptions = [])
    .then(() => log('disconnect WebSocket success'))
    .catch((err) => errorLog('disconnect WebSocket failure', err));
};

export const reconnectWS = () => {
  const tempSubscriptions = { ...subscriptions };
  disconnectWS()
    .then(() => checkWSConnection())
    .then(() => forEach(tempSubscriptions, (sub) => {
      const { options, onMessage, queryName } = sub;
      subscriptions[queryName] = { options, onMessage, queryName };
      subscriptions[queryName].subscription = apolloClient
        .subscribe(options)
        .subscribe({
          next(data) {
            onMessage(data);
          },
        });
    }))
    .then(() => log('reconnect WebSocket success'))
    .catch((err) => errorLog('reconnect WebSocket failure', err));
};
